import { get, patch, destroy } from '../helpers'

const BASE_URL = 'api/v2/seller/amazon_seller_accounts'

export default {
  getAmazonSellerAccounts() {
    return get(BASE_URL)
  },

  getAmazonMarketplacesList() {
    return get('api/junglekit/marketplaces')
  },

  getAmazonSellerAccountStatus(sellerID) {
    return get(`api/junglekit/sellers/${sellerID}/status`)
  },

  patchAmazonSellerAccountDetails({
    sc_email,
    label,
    id,
    default_marketplace_id
  }) {
    return patch(`${BASE_URL}/${id}`, {
      data: {
        sc_email,
        label,
        default_marketplace_id
      }
    })
  },

  deleteAmazonSellerAccount(accountId) {
    return destroy(`${BASE_URL}/${accountId}`)
  },

  patchDismissStatusBar(sellerID, sellerAccountId) {
    return patch(
      `api/junglekit/sellers/${sellerID}/disable_sync_statuses?amazon_seller_account_id=${sellerAccountId}`
    )
  }
}
